import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CLINICS } from '../../constant';

type AlertSettingsPayload = {
  overdueAlertsEnabled?: boolean;
  overdueThresholdDays?: number;
  alertHour?: number;
};

/** Update the clinic's alert settings (admin only). */
export const updateAlertSettings = createAsyncThunk(
  'clinic/updateAlertSettings',
  async (payload: AlertSettingsPayload, { rejectWithValue }) => {
    try {
      const res = await fetch(CLINICS.ALERT_SETTINGS_URL, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to update alert settings');
      }
      return await res.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
